import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { SamplingPointsTypes } from "../../app/types/genericTables.types";

type UseSamplingPointsType = {
  samplingPointsList: SamplingPointsTypes[];
  get: (id: SamplingPointsTypes["id"]) => SamplingPointsTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useSamplingPoints = create<UseSamplingPointsType>((set, get) => ({
  loading: false,
  samplingPointsList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().samplingPointsList.find((samplingPoint) => samplingPoint.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/PuntosMuestreo";
      const { data: response } = await getData(endpoint);
      set(() => ({
        samplingPointsList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useSamplingPoints:", error);
      set({ loading: false });
    }
  },
}));
